import { action } from 'satcheljs';

/**
 * Hides the drag and drop meeting confirmation modal
 */
let hideMeetingDndModal = action('hideMeetingDndModal');
export default hideMeetingDndModal;
